<template>
	<footer class="c-footer">
		<div class="c-footer__inner">
			<div class="c-footer__col">
				<h3>About:</h3>
				<ul class="c-footer__list">
					<li><a href="/about">このサイトについて</a></li>
					<li><a href="/history">更新履歴</a></li>
					<li><a href="https://twitter.com/codogue">@codogue</a></li>
					<li><a href="https://twitter.com/mach3ss">@mach3ss</a></li>
				</ul>
			</div>
			<div class="c-footer__col">
				<h3>Apps:</h3>
				<ul class="c-footer__list">
					<li v-for="app in apps"><a :href="app.path">{{app.name}}</a></li>
				</ul>
			</div>
			<div class="c-footer__col">
				<p class="c-footer__copyright">&copy; Codogue.com All Rights Reserved.</p>
			</div>
		</div>
	</footer>
</template>

<script>

import apps from "../json/apps";

export default {
	name: "c-footer",

	data (){
		return {
			apps: apps
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// footer.vue?18c4ce8c